import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

function Support() {
  return (
    <div className="legal-page">
      <div className="legal-card">
        <div className="legal-header">
          <h1>Monnaify Destek</h1>
          <p className="legal-meta">Yardim ve destek icin bize ulasin.</p>
        </div>

        <p>
          Sorulariniz veya sorunlariniz icin su adresten bize yazabilirsiniz:
          <a href="mailto:support@monnaify.app"> support@monnaify.app</a>
        </p>

        <div className="legal-actions">
          <Link to="/privacy">Gizlilik Politikasi</Link>
          <Link to="/">Giris</Link>
        </div>
      </div>
    </div>
  );
}

export default Support;
